import React from 'react';

const AppFooter = ({ className = '', children }) => {
  return (
    <footer className={`border-t bg-slate-900 py-6 mt-auto ${className}`}>
      <div className="container mx-auto px-6 text-center">
        <p className="text-sm text-slate-400">
          © 2025 Priyanka Jha | IF™
        </p>
        <p className="text-xs text-slate-500 mt-2 italic">
          Human Creativity. AI Partnership. Responsible Innovation.
        </p>
        {children && <div className="mt-2">{children}</div>}
      </div>
    </footer>
  );
};

export default AppFooter;
